function log(type, ...text){
    let temp = [].concat.call(text).join();
    switch (type) {
        case "warn":
        case 1:
            console.log("%cLR | %c" + temp,"color:#00BADB; font-style:bold", "color:#ff9626; font-style:bold")
            break;
        case "error":
        case 2:
            console.log("%cLR | %c" + temp,"color:#00BADB; font-style:bold", "color:#eb3434; font-style:bold")
            break;
        case "success":
        case 3:
            console.log("%cLR | %c" + temp,"color:#00BADB; font-style:bold", "color:#007029; font-style:bold")
            break;
        case "info":
        case 4:
            console.log("%cLR | %c" + temp,"color:#00BADB; font-style:bold", "color:#009ddb; font-style:bold")
            break;
        default:
            console.log("%cLR |", "color:#00BADB; font-style:bold", ...text)
    };
};

export const cl = {log};